export default '__THEMING__';


//////////////////
// WEBPACK FOOTER
// ./~/theming/dist/esm/channel.js
// module id = 165
// module chunks = 2